import React, { useCallback } from 'react';
import { TrackerExtraInfoProps } from '@diritto/common/tracker/tracking-event.constant';
import { useContentReaction } from 'state-hooks/contents/useContentReaction';
import { FavoriteButton, NotiButton } from 'ui-components/navigations/HeaderButtons';

interface ContentFavoriteButtonProps {
  contentId: number;
  color?: string;
  opacity?: number;
}

export const ContentFavoriteAndEpisodeNotiButton = ({
  contentId,
  color,
  opacity = 1,
  trackerExtraInfo,
}: ContentFavoriteButtonProps & TrackerExtraInfoProps) => {
  const {
    noti: { isNoti },
    favorite: { isFavorite },
    toggleFavorite,
    toggleNoti,
  } = useContentReaction(contentId);

  const handleClickFavorite = useCallback(
    (event?: React.SyntheticEvent) => {
      event?.stopPropagation();
      toggleFavorite({ trackerExtraInfo });
    },
    [toggleFavorite, trackerExtraInfo],
  );

  const handleClickNoti = useCallback(
    (event?: React.SyntheticEvent) => {
      event?.stopPropagation();
      toggleNoti();
    },
    [toggleNoti],
  );

  return (
    <>
      <FavoriteButton fill={isFavorite} onClick={handleClickFavorite} color={color} opacity={opacity} />
      {isFavorite && <NotiButton fill={isNoti} onClick={handleClickNoti} color={color} opacity={opacity} />}
    </>
  );
};

export default ContentFavoriteAndEpisodeNotiButton;
